import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-dark-950 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* 회사 정보 */}
          <div className="col-span-1 md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/01721397da55af21878e201cee4469af/22d693b8e5c7b9a7815f6764c73619aa.png" 
              alt="CEIS Logo" 
              className="h-10 mb-4"
            />
            <p className="text-gray-400 mb-4 max-w-md">
              클라우드 기반 온라인 증명서 발급 및 관리 플랫폼으로, 교육기관과 학습자를 위한 
              간편하고 안전한 증명서 솔루션을 제공합니다.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center glass-card hover:bg-white/10 rounded-full transition-all cursor-pointer">
                <i className="ri-facebook-fill text-gray-300"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center glass-card hover:bg-white/10 rounded-full transition-all cursor-pointer">
                <i className="ri-twitter-fill text-gray-300"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center glass-card hover:bg-white/10 rounded-full transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-gray-300"></i>
              </a>
            </div>
          </div>

          {/* 서비스 */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">서비스</h3>
            <ul className="space-y-2">
              <li><Link to="/features" className="text-gray-400 hover:text-white transition-colors">기능 소개</Link></li>
              <li><Link to="/pricing" className="text-gray-400 hover:text-white transition-colors">요금제</Link></li>
              <li><Link to="/demo" className="text-gray-400 hover:text-white transition-colors">데모 체험</Link></li>
              <li><Link to="/api" className="text-gray-400 hover:text-white transition-colors">API 문서</Link></li>
            </ul>
          </div>

          {/* 지원 */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">지원</h3>
            <ul className="space-y-2">
              <li><Link to="/support" className="text-gray-400 hover:text-white transition-colors">고객지원</Link></li>
              <li><Link to="/faq" className="text-gray-400 hover:text-white transition-colors">자주 묻는 질문</Link></li>
              <li><Link to="/guide" className="text-gray-400 hover:text-white transition-colors">사용 가이드</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors">문의하기</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © 2024 CEIS. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacy" className="text-gray-500 hover:text-white text-sm transition-colors">
              개인정보처리방침
            </Link>
            <Link to="/terms" className="text-gray-500 hover:text-white text-sm transition-colors">
              이용약관
            </Link>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-500 hover:text-white text-sm transition-colors">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
